import MailRoutes from './MailRoutes';

export { MailRoutes };
